import {GroupCheckboxRoot} from './components/group-checbox-root';
import {GroupCheckboxItem} from './components/group-checkbox-item';

export const CheckboxGroup = {
	Root: GroupCheckboxRoot,
	Checkbox: GroupCheckboxItem,
};
